import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Styles from './ErrorRow.module.scss';

function ErrorRow({ colSpan, error }: Readonly<{ colSpan: number; error: string | null }>): React.ReactElement {
    return (
        <TableRow id={Styles.ErrorRow}>
            <TableCell colSpan={5} className={Styles.error}>{error}</TableCell>
        </TableRow>
    );
}

export default ErrorRow;
